export const DAYS = [
  { day: "Sunday", closed: true },
  { day: "Monday", closed: false, from: "09:00 AM", to: "02:00 PM" },
  { day: "Tuesday", closed: false, from: "09:00 AM", to: "08:00 PM" },
  { day: "Wednesday", closed: false, from: "09:00 AM", to: "02:00 PM" },
  { day: "Thursday", closed: false, from: "09:00 AM", to: "07:00 PM" },
  { day: "Friday", closed: false, from: "09:00 AM", to: "03:00 PM" },
  { day: "Saturday", closed: true },
];

export const UPLOADED_DOCUMENTS = [
  {
    id: 1,
    name: "Business License.pdf",
    uploadedOn: "December 15, 2025",
    status: "Uploaded",
  },
  {
    id: 2,
    name: "Insurance Certificate.pdf",
    uploadedOn: "January 03, 2026",
    status: "Uploaded",
  },
  {
    id: 3,
    name: "Tax Registration.pdf",
    uploadedOn: "January 10, 2026",
    status: "Uploaded",
  },
];

export const AFP_DOCUMENTS = [
  {
    title: "Service Provider Agreement",
    description: "Review and acknowledge this document",
  },
  {
    title: "Privacy Policy",
    description: "Review and acknowledge this document",
  },
  {
    title: "Terms of Service",
    description: "Review and acknowledge this document",
  },
  {
    title: "Non-Disclosure Agreement",
    description: "Review and acknowledge this document",
  },
];

export const UPLOAD_CRITERIA = [
  "Supported formats: JPEG, PNG, WebP",
  "Maximum file size: 5MB per image",
  "Recommended dimensions: 1200x800 pixels or higher",
  "Use high-quality, well-lit images showcasing your service",
  "Maximum 5 images allowed",
  "Avoid images with watermarks or text overlays",
];
